// extracted by mini-css-extract-plugin
export default {"heading":"_3zMo1djaEp6HOBVvFNCZmo","container":"_6X7JBBvl0Egb3MiKhQpXIt"};